import { getFormattedTime, debugWallet } from 'wallet-manager';
const trackUDSLoadTime = (ecommerce, udsInitializationTime, listingVin, listingId) => {
  if ((process.env.NEXT_PUBLIC_ENVIRONMENT || process.env.ENVIRONMENT) === 'prod') {
    // Return null for production environment
    return null;
  }
  const endTime = getFormattedTime();
  const timeDifference = (udsInitializationTime.raw - endTime.raw)?.toString()?.slice(1);
  if (window && window?.newrelic?.addPageAction) {
    window.newrelic.addPageAction('UDSLoadTime', {
      tenant: ecommerce,
      component: 'NativeDealCalculator',
      message: 'To measure UDS Load Time',
      url: window.location.href,
      initializationTime: udsInitializationTime.formatted,
      udsLoadedAt: endTime.formatted,
      timeLaps: timeDifference,
      vin: listingVin,
      listingId
    });
  }
  if (ecommerce) {
    debugWallet('UDS', `Time metrics - UDSInitializationTime: ${udsInitializationTime.formatted}, UDSLoadedAt: ${endTime.formatted}, timeLaps: ${timeDifference}`);
  }
  return timeDifference;
};
export { trackUDSLoadTime as default };
